import { FC, memo, useMemo } from 'react';
import { Trans } from 'react-i18next';

import { useCMSGameCovers } from '../../../hooks';
import { GameCardWrapper } from '../GameCardWrapper';
import { GameV1 } from '@/api/games';
import { ImageComponent } from '@/components/Image';
import { getGameCover } from '@/helpers/cdn';
import { TCardMode } from '@/modules/game/types';
import { useCommonStore } from '@/store';

import {
  ScLockedGameCardIcon,
  ScLockedGameCardInner,
  ScLockedGameCardMessage,
} from './styled';

interface ILockedGameCardProps {
  game: GameV1;
  mode: TCardMode;
  withoutBottom?: boolean;
}

export const LockedGameCard: FC<ILockedGameCardProps> = memo(
  ({ game, mode, withoutBottom }) => {
    const { id } = game;
    const user = useCommonStore.use.user();

    const { covers } = useCMSGameCovers();

    const url = useMemo(() => {
      return covers?.[id]?.cover?.url || getGameCover(id);
    }, [covers, id]);

    return (
      <GameCardWrapper game={game} mode={mode} withoutBottom={withoutBottom}>
        <ScLockedGameCardInner>
          <ImageComponent
            alt="cover"
            src={url}
            loading="lazy"
            fill
            className="cover-image"
          />
          <div className="content">
            <ScLockedGameCardIcon>
              <ImageComponent
                src="/game/locked-card-icon.svg"
                width={16}
                height={16}
                alt="play button icon"
              />
            </ScLockedGameCardIcon>
            <ScLockedGameCardMessage>
              <Trans
                ns="common"
                i18nKey="noCurrency"
                values={{ currency: user?.currency }}
                components={{ 2: <strong /> }}
              />
            </ScLockedGameCardMessage>
          </div>
        </ScLockedGameCardInner>
      </GameCardWrapper>
    );
  }
);
